import type { DashboardOptions } from '../model';

const formatNumber = (value: number, fractionDigits = 1): string =>
  value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });

/**
 * Formats a dashboard metric value for display. Shared across all dashboard pages
 * (service users, storage overview, transport overview).
 *
 * The raw value is already in the displayed unit — do NOT divide weight by 1000
 * (that was the `342406` bug).
 *
 * @example
 * formatValue(1727.9445836679997, 'W'); // '1,727.9 mt'
 * formatValue(1658.3585309499997, 'W'); // '1,658.4 mt'
 */
export const formatValue = (value: number, metric?: DashboardOptions['metric']): string => {
  switch (metric) {
    case 'W':
      return `${formatNumber(value)} mt`;
    case 'V':
      return `${formatNumber(value)} m³`;
    case 'VA':
      return `$${value.toLocaleString('en-US')}`;
    default:
      return value.toLocaleString('en-US');
  }
};
